import * as Types from 'src/actions/project/offline-investor/create/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { RootState } from 'src/reducers/RootReducer';
import OfflineInvestor from 'src/entities/OfflineInvestor';
import { AxiosResponse } from 'axios';
import ValidatorService from 'src/services/validation/Validation.service';
import { Validation } from 'src/services/validation/Validator';

export interface CreateOfflineInvestorAttempt extends Action {
  type: Types.CREATE_OFFLINE_INVESTOR_ATTEMPT;
}

export interface CreateOfflineInvestorSuccess extends Action {
  type: Types.CREATE_OFFLINE_INVESTOR_SUCCESS;
  payload: OfflineInvestor;
}

export interface CreateOfflineInvestorFailure extends Action {
  type: Types.CREATE_OFFLINE_INVESTOR_FAILURE;
  payload: {};
}

export type CreateOfflineInvestorAction =
  CreateOfflineInvestorAttempt
  | CreateOfflineInvestorSuccess
  | CreateOfflineInvestorFailure;

export interface CreateOfflineInvestorThunk extends ThunkAction<Promise<CreateOfflineInvestorAction>, RootState,
  string> {
}

export const createOfflineInvestorAttempt: ActionCreator<CreateOfflineInvestorAttempt> = () => (
  {
    type: Types.CREATE_OFFLINE_INVESTOR_ATTEMPT
  }
);

export const createOfflineInvestorSuccess: ActionCreator<CreateOfflineInvestorSuccess> = (
  investor: OfflineInvestor
) => ({
  type: Types.CREATE_OFFLINE_INVESTOR_SUCCESS,
  payload: investor,
});

export const createOfflineInvestorFailure: ActionCreator<CreateOfflineInvestorFailure> = (error: {}) => (
  {
    type: Types.CREATE_OFFLINE_INVESTOR_FAILURE,
    payload: error
  }
);

export const createOfflineInvestor: ActionCreator<CreateOfflineInvestorThunk> =
  (id: string, offlineInvestor: OfflineInvestor): CreateOfflineInvestorThunk => {
    return (dispatch: Dispatch<RootState>): Promise<CreateOfflineInvestorAction> => {

      dispatch(createOfflineInvestorAttempt());

      let restrictions: Validation[] = [
        { value: offlineInvestor.name, message: 'name' },
        { value: offlineInvestor.investmentType, message: 'investmentType' },
        { value: offlineInvestor.amountInvested, type: 'amountInvested' },
      ];

      const validation = ValidatorService.validate(restrictions);

      return validation.then(() => {

        return ApiClient.offlineInvestor.create(offlineInvestor, { projectId: id })
          .then((response: AxiosResponse): CreateOfflineInvestorSuccess => {
            return dispatch(createOfflineInvestorSuccess(new OfflineInvestor(response.data.content)));
          }).catch((e: { response: { data: { errors: {} } } }): CreateOfflineInvestorFailure => {
            const errorMessages = ValidatorService
              .translateValidations(e && e.response && e.response.data && e.response.data.errors);

            return dispatch(createOfflineInvestorFailure(errorMessages));
          });
      }).catch((errors) => {
        return dispatch(createOfflineInvestorFailure(errors));
      });
    };
  };



// WEBPACK FOOTER //
// ./src/actions/project/offline-investor/create/CreateOfflineInvestor.actions.tsx